import { MaskText, Reveal } from "@/components/motion/Reveal";

// Dark cinematic hero band for interior pages. Header sits transparent over this.
export default function PageHero({ eyebrow, titleLines = [], intro, image }) {
  return (
    <section className="relative bg-ptf-primary text-ptf-bg overflow-hidden grain">
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-25"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ptf-primary via-ptf-primary/70 to-ptf-primary/40" />
        </>
      )}
      <div className="relative z-10 mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12 pt-36 pb-14 md:pt-44 md:pb-20">
        {eyebrow && (
          <Reveal>
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-ptf-accent mb-6 flex items-center gap-3">
              <span className="h-px w-8 bg-ptf-accent inline-block" />
              {eyebrow}
            </p>
          </Reveal>
        )}
        <MaskText
          tag="h1"
          lines={titleLines}
          className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tight max-w-5xl"
        />
        {intro && (
          <Reveal delay={0.2}>
            <p className="mt-7 max-w-2xl text-base md:text-lg text-ptf-bg/75 leading-relaxed font-light">
              {intro}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
